import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isHovered: false,
      isSelected: false,
      _selectableId: null
    };
  },
  computed: {
    ...mapGetters('workbench/formBuilder', ['MAPPABLE_TYPES']),
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    // Generate a unique ID for this instance
    this._selectableId = `selectable_${Date.now()}_${Math.random()}`;
    // Listen for global deselect events
    // document.addEventListener('deselect-all-previews', this.handleGlobalDeselect);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    // document.removeEventListener('deselect-all-previews', this.handleGlobalDeselect);
  },
  methods: {
    deselect() {
      this.isSelected = false;
      this.isHovered = false;
      if (typeof this.onDeselected === 'function') {
        this.onDeselected();
      }
    },
    // handleSelect(e) {
    //   // Emit event to deselect all other previews
    //   const deselectEvent = new CustomEvent('deselect-all-previews', {
    //     detail: { exceptId: this._selectableId }
    //   });
    //   document.dispatchEvent(deselectEvent);
      
    //   this.isSelected = true;
    //   if (e) {
    //     e.stopPropagation();
    //   }
    // },
    // triggerDeselectOthers() {
    //   // Trigger deselection of all other previews (used when entering edit mode)
    //   const deselectEvent = new CustomEvent('deselect-all-previews', {
    //     detail: { exceptId: this._selectableId }
    //   });
    //   document.dispatchEvent(deselectEvent);
    // },
    // handleGlobalDeselect(e) {
    //   // Deselect this preview unless it's the one that triggered the event
    //   if (e.detail && e.detail.exceptId !== this._selectableId) {
    //     this.deselect();
    //   }
    // },
    handleClickOutside(e) {
      const containerRef = this.$refs.previewContainer || this.$refs.wrapperContainer;
      if (containerRef && !containerRef.contains(e.target)) {
        this.deselect();
      }
    }
  }
};
